export default "__VITE_ASSET__COGBdCDt__"